import React from 'react';
import SkeletonLoader from "../../Components/SkeletonLoader/SkeletonLoader";
var css = {
  "pageLoading": "oalp-14My_"
};
export var PageLoadingWidget = function PageLoadingWidget() {
  return /*#__PURE__*/React.createElement(SkeletonLoader, {
    className: css.pageLoading
  });
};
export default PageLoadingWidget;